import React from 'react';
import { Link, matchPath } from 'react-router-dom';
import styled, { css } from 'styled-components';
import { faUser } from '@fortawesome/free-solid-svg-icons';
import { company } from './config';
import { getCurrentWeek, getCurrentYear } from './routes/RegisterSlaughter/util';
import { getInFourWeeks, getInTreeWeeks, incrementWeek } from './utils/date.utils';

import {
  Row, Label, Icon, Cell,
} from './components/Layout';
import { routes } from './routes/routes.manifest';
import { getBrandingColor, colorTypes } from './branding';

// all things that varies between slaughterhouse (REACT_APP_COMPANY in config), should be placed here

export const getFeaturesEnabled = () => {
  if (company === 'furuseth') {
    return {
      debit_total_in_dashboard: false,
      temp_accountings: true,
      purke_raane_individual_registration: true,
      pickup_location_for_return_meat: false,
      branding_clothes: true,
      'helsegris-check': true,
      enrolmentWantReturnMarksCheckbox: true,
      return_form: true,
      return_info: false,
      show_medication_holdback_info_on_enrolmentpage: false,
      extraCheckboxConfirmRegisterSlaughter: false,
      prognosisRegistration: true,
    };
  }
  if (company === 'midtnorge') {
    return {
      debit_total_in_dashboard: true,
      temp_accountings: false,
      breadcrumbs: true,
      'helsegris-check': true,
      purke_raane_individual_registration: false,
      pickup_location_for_return_meat: true,
      branding_clothes: true,
      enrolmentWantReturnMarksCheckbox: false,
      return_form: false,
      return_info: true,
      show_medication_holdback_info_on_enrolmentpage: true,
      extraCheckboxConfirmRegisterSlaughter: true,
      prognosisRegistration: false,
    };
  }

  return {};
};
export const getSlaughterRegistrationDeadline = (variant) => ({
  midtnorge: {
    normal: {
      weekday: 2, // monday = 1
      hour: 6,
      minute: 0,
    },
    cattleAgreement: {
      weekday: 1,
      hour: 24,
      minute: 0,
    },
  },
  furuseth: {
    normal: {
      weekday: 3,
      hour: 7,
      minute: 30,
    },
    pigs_buy:{
      weekday: 1,
      hour: 7,
      minute: 30,
    },
    pigs_sell:{
      weekday: 1,
      hour: 7,
      minute: 30,
    },
    cattle_buy:{
      weekday: 1,
      hour: 7,
      minute: 30,
    },
    cattle_sell:{
      weekday: 1,
      hour: 7,
      minute: 30,
    },
    sheep_buy:{
      weekday: 1,
      hour: 7,
      minute: 30,
    },
    sheep_sell:{
      weekday: 1,
      hour: 7,
      minute: 30,
    },
    cattleAgreement: {
      weekday: 3,
      hour: 7,
      minute: 30,
    },
  },
}[company][variant]);

export const getSlaughterDeletionnDeadline = () => ({
  midtnorge: {
    weekday: 2, // monday = 1
    hour: 6,
    minute: 0,
  },
  furuseth: {
    weekday: 3,
    hour: 7,
    minute: 0,
  },
}[company]);

export const getDefaultBasisYearAndWeekForSelected = (
  animalKind,
  cattleAgreement,
) => {
  const thisWeek = getCurrentWeek();
  const thisYear = getCurrentYear();

  const [year1, week1] = incrementWeek(thisYear, thisWeek);
  const [year2, week2] = incrementWeek(year1, week1);

  const [year3, week3] = getInTreeWeeks(thisYear, thisWeek);
  const [year4, week4] = getInFourWeeks(thisYear, thisWeek);

  if (animalKind === 'pigs' || animalKind === 'sheep') {
    return [year1, week1];
  }

  if (animalKind === 'cattle') {
    if (cattleAgreement) {
      if (company === 'furuseth') {
        return [year3, week3];
      }
      if (company === 'midtnorge') {
        return [year4, week4];
      }
    } else {
      if (company === 'furuseth') {
        return [year1, week1];
      }
      if (company === 'midtnorge') {
        return [year1, week1];
      }
    }
  }

  return [year1, week1];
};

const StyledRow = styled(Row)`
  width: calc(100% - 28px - 28px);/*subtract the left and right padding*/
  margin-top: 16px;
  height: fit-content;
  margin-top: auto;
  flex-shrink: 0;
  padding: 17px 28px;
  height: 1.5rem;

  [name='hover'] {
    :hover {
      cursor: pointer;
    }
  }
`;

const HoverRow = styled(StyledRow)`
    :hover {
      cursor: pointer;
    }
  `;

export const BottomMenuFuruseth = ({ location, history }) => {
  if (
    matchPath(location.pathname, {
      path: routes.profileEdit,
    })
  ) {
    return null;
  }
  return matchPath(location.pathname, {
    exact: true,
    path: routes.profile,
  }) ? (
    <HoverRow
      background={getBrandingColor(colorTypes.primary)}
      marginTop="auto"
      aria-label="Gå tilbake til forrige side"
      role="button"
      onClick={() => {
        // when the user has been in edit-profile, Close profile should actually close the profile
        // and go back to the page the user visited before profile, and not back to edit profile
        if (location.state && location.state.referer === routes.profileEdit) {
          history.go(-2);
        } else {
          history.goBack();
        }
      }}
    >
      <div
        aria-hidden="true"
        role="button"
        name="hover"
        style={{ color: 'white', marginLeft: '0.3rem' }}
        css={css`
          text-decoration: none;
        `}
      >
        <Label
          color="#fff"
          marginLeft="1.41em"
          marginBottom="0.2em"
          inline
          aria-hidden="true"
          size="1rem"
        >
          Lukk Min Konto
        </Label>
      </div>
    </HoverRow>
    ) : (
      <StyledRow
        background={getBrandingColor(colorTypes.primary)}
        style={{
          display: 'block',
          position: 'absolute',
          marginTop: '16px',
          bottom: '0',
          color: 'transparent',
        }}
        as={Link}
        to={routes.profile}
      >
        <div
          name="hover"
          aria-hidden="true"
          style={{ color: 'white', marginLeft: '0.3rem' }}
          css={css`
          text-decoration: none;
        `}
        >
          <Icon
            icon={faUser}
            aria-hidden="true"
            style={{ float: 'left', marginRight: '0.5em' }}
          />
          <Cell marginLeft="12px" inline aria-hidden="true">
            Min konto
          </Cell>
        </div>
      </StyledRow>
    );
};

const BottomMenuMidtnorgeWrapper = styled(StyledRow)`
      display: block;
      width: 100%;
      position: absolute;
      margin-top: 16px;
      bottom: 0;
      color: transparent;
      padding-top: 15px;
      padding-bottom: 20px;
      height: 2.3em;
      padding-left: 0;

  @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
    /* IE10+ specific styles go here */
    position: fixed;
  }
`;

export const BottomMenuMidtnorge = () => (
  <BottomMenuMidtnorgeWrapper
    background={getBrandingColor(colorTypes.primary)}
    style={{
    }}
  >
    <div style={{ color: 'white', textAlign: 'center', fontSize: '0.75em' }}>
      <Label style={{ fontWeight: 'bold' }}>Midt-Norge Slakteri AS</Label>
      <Label>Kirkegata 70, 7600 LEVANGER</Label>
      <Label>
        Telefon: 74 08 37 00
        {' '}
        <span aria-hidden="true">•</span>
        {' '}
        E-post:
        <a href="mailto: postmottak@norsk-slakt.no" style={{ color: 'white' }}>postmottak@norsk-slakt.no</a>
      </Label>
    </div>
  </BottomMenuMidtnorgeWrapper>
);

export const getSlaughterhouseSpecificComponent = (component) => ({
  furuseth: {
    bottomMenu: BottomMenuFuruseth,
  },
  midtnorge: {
    bottomMenu: BottomMenuMidtnorge,
  },
}[company][component]);

export const getSlaugherhouseSpecificSheepBuySellKinds = () => {
  if (company === 'furuseth') {
    return [];
  } else if (company === 'midtnorge') {
    return ['Grå Trønder'];
  }
  return [];
};
